import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router';
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import tools from "@/composables/tools";


import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';


import { currentUserStore } from '@/stores/currentUser'
import { useMensajesUnreadStore } from '@/stores/mensajesUnread'
import { useAvisoApp } from '@/composables/useAvisoApp'
import { User } from '@/interfaces/User';
import { syncDisciplinasActivas, syncProfesores, syncProfesoresIfNeeded } from '@/services/indexedDB';
import { enforceFreshDeploy } from '@/utils/deployVersion';
import { setupAppLinkRouting } from '@/utils/appLinks';

const pinia = createPinia()


const app = createApp(App)
  .use(IonicVue)
  .use(pinia)
  .use(VueAxios,axios)
  .use(router);
 
  moment.locale('es');
 
  app.config.globalProperties.$filters = {
    timeAgo(date:string) {
      return moment(date).fromNow()
    },
    human(date:string) {
      let val = moment(date).format('dddd D')
      val += ' de '
      val += moment(date).format('MMMM')
      return val
    },
  }
  

Promise.all([router.isReady(), enforceFreshDeploy()]).then(() => {
  setupAppLinkRouting(router);
  app.mount('#app');
});

router.beforeEach((to) => {
  if(to.meta.requiredAuth && localStorage.getItem('user')==undefined)
  {
      currentUserStore().$state.redirectAfterLogin = to.fullPath
      router.push({path: "/login"});
  }
  return true
})


axios.defaults.baseURL = process.env.VUE_APP_SERVICE_URL
axios.defaults.headers.common["Accept"] = "application/json"
if(localStorage.getItem("token"))
  axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");

const NETWORK_TOAST_COOLDOWN_MS = 12000
let lastNetworkToastAt = 0

// Interceptor: 401 → login; otros errores con mensaje seguro (500 puede no traer JSON con .message)
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    const data = error.response?.data
    const msg =
      data && typeof data === 'object' && data !== null && 'message' in data && data.message != null
        ? String((data as { message?: unknown }).message)
        : typeof data === 'string'
          ? data
          : error.message ?? 'Error del servidor'

    // Tracking fire-and-forget: no molestar al usuario si falla log/set
    if (error.config?.skipErrorToast) {
      return Promise.reject(error)
    }

    if (status === 401) {
      console.log(error.response)
      // Token caducado/inválido: limpiar sesión para evitar bucles de reintentos.
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common.Authorization
      useMensajesUnreadStore(pinia).resetAndStop()
      useAvisoApp().resetAndStop()
      if (router.currentRoute.value.path !== '/login') {
        tools().toast(msg, 'danger')
        void router.push({ path: "/login" })
      }
    } else {
      const isNetworkLikeError =
        !status && /network error|timeout|failed to fetch/i.test(String(msg).toLowerCase())
      if (isNetworkLikeError) {
        const now = Date.now()
        if (now - lastNetworkToastAt >= NETWORK_TOAST_COOLDOWN_MS) {
          lastNetworkToastAt = now
          tools().toast('No se puede conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.', 'danger', 7000)
        }
      } else {
        tools().toast(msg, 'danger', 10000)
      }
    }
    return Promise.reject(error)
  }
)

//** guardamo como state los datos del usuario logeado */
const userJson = localStorage.getItem('user');
const currentUserObj:User = userJson !== null ? JSON.parse(userJson):{ id: 0 }
const currentUser = currentUserStore()
currentUser.update(currentUserObj)

//si en el localStorage hay un token, solicitamos los datos al servidor y lo logeamos
if(localStorage.getItem('token'))
{
  syncDisciplinasActivas();
  syncProfesores(); //en cada arranque (incluido F5) sincronizamos profesores

  axios.get('/user').then(response => {
    currentUser.update(response.data)
    localStorage.setItem('user',JSON.stringify(response.data))
  }).catch(() => { /* 401 lo gestiona el interceptor */ })
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState !== 'visible') return;
  void enforceFreshDeploy();
  if (!localStorage.getItem('token')) return;
  void syncProfesoresIfNeeded().catch(() => { /* noop */ });
});

